import WireWidgetCard, { StatusPill } from "./WireWidgetCard";
import {
  formatWireAmount,
  formatWireDate,
  getPayoutProgress,
  getPayoutDeclineReason,
  getWireAmount,
  getWireCreatedDate,
} from "../wireUtils";

/**
 * Automatic monthly pay-out. The setting (enabled) and the current month's
 * request are independent: disabling the setting does not cancel an open
 * request, so the open request is still shown while disabled.
 */
const AutomaticPayoutWidget = ({
  autoPayout,
  currentAutoPayout,
  lastDeclined,
  onEnable,
  onEdit,
  onDisable,
}) => {
  const enabled = !!autoPayout?.enabled;
  const minPB = formatWireAmount(autoPayout?.minimumPB ?? 0);
  const titleState = enabled
    ? { text: "Enabled", tone: "enabled" }
    : { text: "Disabled", tone: "disabled" };

  const enabledActions = [
    { id: "auto-payout-edit", label: "Edit settings", onClick: onEdit },
    { id: "auto-payout-disable", label: "Disable", onClick: onDisable },
  ];
  const enableAction = [
    { id: "auto-payout-enable", label: "Enable autopayout", onClick: onEnable },
  ];

  let body;
  let actions;

  if (currentAutoPayout) {
    const month = formatWireDate(getWireCreatedDate(currentAutoPayout), { monthOnly: true });
    const amount = formatWireAmount(getWireAmount(currentAutoPayout));
    const progress = getPayoutProgress(currentAutoPayout);
    actions = enabled ? enabledActions : enableAction;
    body = (
      <>
        {enabled && (
          <div className="widget-line">
            <span className="widget-label">Minimum PB to keep</span>
            <span className="widget-value">{minPB}</span>
          </div>
        )}
        <div className="widget-line">
          <span className="widget-label">{month} request</span>
        </div>
        <div className="widget-amount">
          {amount}
          <StatusPill progress={progress} />
        </div>
        {!enabled && <div className="widget-muted">Existing request continues.</div>}
      </>
    );
  } else if (enabled && lastDeclined) {
    const reason = getPayoutDeclineReason(lastDeclined) || "insufficient funds";
    actions = enabledActions;
    body = (
      <>
        <div className="widget-line">
          <span className="widget-label">Minimum PB to keep</span>
          <span className="widget-value">{minPB}</span>
        </div>
        <div className="widget-declined">Last payout declined: {reason}</div>
      </>
    );
  } else if (enabled) {
    actions = enabledActions;
    body = (
      <>
        <div className="widget-line">
          <span className="widget-label">Minimum PB to keep</span>
          <span className="widget-value">{minPB}</span>
        </div>
        <div className="widget-muted">A new payout request is created each month.</div>
      </>
    );
  } else {
    actions = enableAction;
    body = (
      <div className="widget-muted">
        Create a payout request once a month. Choose the minimum Performance Bond to keep.
      </div>
    );
  }

  return (
    <WireWidgetCard title="Automatic payout" titleState={titleState} actions={actions}>
      {body}
    </WireWidgetCard>
  );
};

export default AutomaticPayoutWidget;
